import { createEffect, createStore } from "effector";
import { confirmChangeBaseSelections } from "./confirmChangeFns";
import { resetAllSelectedStores } from "./resetAllSelected";

export type SelectedDatesValue = Date[] | null;
export const $selectedDates = createStore<SelectedDatesValue>(null).reset(
  resetAllSelectedStores
);
export const setSelectedDates = createEffect(
  async (value: SelectedDatesValue): Promise<SelectedDatesValue> => {
    if (!(await confirmChangeBaseSelections())) {
      throw new Error("User declined date range change.");
    }
    return value;
  }
);
$selectedDates.on(setSelectedDates.doneData, (s, value) => value);

export type SelectedPreferredDays = number[] | number | null;
export const $selectedPreferredDays = createStore<SelectedPreferredDays>(
  null
).reset(resetAllSelectedStores);
export const setSelectedPreferredDays = createEffect(
  async (value: SelectedPreferredDays): Promise<SelectedPreferredDays> => {
    if (!(await confirmChangeBaseSelections())) {
      throw new Error("User declined date range change.");
    }
    return value;
  }
);
$selectedPreferredDays.on(setSelectedPreferredDays, (s, value) => value);
